<app-calendar-component
  [events]="eventos"
  (selectedDateEvent)="onSelectDate($event)"
  (slideChangedEvent)="onSlidechanged($event)"
>
</app-calendar-component>
